import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    (async () => {
      if (!sessionId) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const { data } = await api.post("/auth/google-session", { session_id: sessionId });
        login(data.token, data.user);
        toast.success(`Welcome${data.user.name ? `, ${data.user.name.split(" ")[0]}` : ""}`);
        // strip hash and route
        window.history.replaceState(null, "", "/");
        navigate(data.user.is_admin ? "/admin" : "/dashboard", { replace: true });
      } catch (e) {
        toast.error(e?.response?.data?.detail || "Sign-in failed");
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, login]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <span className="spinner" />
    </div>
  );
}
